import {createLazyFileRoute} from '@tanstack/react-router'

import Account from '@/views/Account/Account'

export const Route = createLazyFileRoute('/_account')({
  component: Account,
})
